import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import { problemKeys } from "app/utils/constants/problem";

const KeyOperatorFilter = ({ keysWithOperators, onKeyChange }) => {
  return (
    <Tooltip
      title={
        keysWithOperators.length > 0
          ? `${keysWithOperators.map(({ key }) => problemKeys[key]).join(", ")}`
          : "Select fields to filter by"
      }
      placement="top"
      arrow
    >
      <FormControl
        sx={{
          m: 1,
          width: 120,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
        }}
        size="small"
      >
        <Select
          multiple
          value={keysWithOperators.map(({ key }) => key)}
          onChange={(e) => onKeyChange(e.target.value || [])}
          displayEmpty
          renderValue={(selected) =>
            selected.length > 0 ? (
              selected.map((key) => problemKeys[key]).join(", ")
            ) : (
              <span>Filter</span>
            )
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          input={
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <TuneIcon />
                </InputAdornment>
              }
            />
          }
        >
          {Object.entries(problemKeys).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default KeyOperatorFilter;
